import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useAddRoleDialogStyles = makeStyles({
  responsibilitiesList: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    marginTop: designTokens.spacing[1],
  },
  responsibilityRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    "& > :first-child": {
      flex: "1",
    },
  },
  addResponsibilityButton: {
    alignSelf: "flex-start",
    color: projectIqTokens.teal,
    paddingLeft: "0",
    minWidth: "unset",
  },
});
